export default __webpack_public_path__ + "static/media/treasuries.cc5664f2.svg";